import { useMutation, useQueryClient } from "@tanstack/react-query";

const STORAGE_KEY = "squawk.playerV2Enabled";

export const useSetSquawkPlayerV2 = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (enabled: boolean) => {
      localStorage.setItem(STORAGE_KEY, String(enabled));
      return Promise.resolve();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["squawkPlayerV2Pref"] });
    },
  });
};
